import { Capacitor, registerPlugin } from '@capacitor/core';
import { Haptics } from '@capacitor/haptics';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Share } from '@capacitor/share';

import { NATIVE_BIOMETRIC_PLUGIN, NATIVE_WEBKIT_HANDLER } from '../constants/bridge';
import { createCapacitorAdapter } from './adapters/capacitor';
import { createIframeAdapter } from './adapters/iframe';
import { createWebAdapter } from './adapters/web';
import { createWebKitAdapter } from './adapters/webkit';
import { createNativeBridge } from './native-bridge';

export function selectAdapter({ win = window, capacitor = Capacitor, embedHostOrigin = null, plugins } = {}) {
    // Plugin web fallbacks are never used: in a browser the @capacitor/haptics
    // web shim reports success even on desktops without a vibration motor.
    if (capacitor.isNativePlatform()) {
        return createCapacitorAdapter({ capacitor, ...plugins });
    }
    const webkitHandler = win.webkit?.messageHandlers?.[NATIVE_WEBKIT_HANDLER];
    if (webkitHandler) {
        return createWebKitAdapter({ handler: webkitHandler });
    }
    if (embedHostOrigin && win.parent && win.parent !== win) {
        return createIframeAdapter({ win, hostOrigin: embedHostOrigin });
    }
    return createWebAdapter({ win });
}

export function createPlatformBridge({ embedHostOrigin = null } = {}) {
    const plugins = {
        share: Share,
        haptics: Haptics,
        notifications: LocalNotifications,
        biometric: registerPlugin(NATIVE_BIOMETRIC_PLUGIN),
    };
    return createNativeBridge({ adapter: selectAdapter({ embedHostOrigin, plugins }) });
}
